<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <b-alert
            class="b-alert-saved"
            :show="dismissCountDown"
            dismissible
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
        >
            {{ $t('saved') }}
        </b-alert>

        <div class="container font-bold text-gray-500 text-2xl py-4">
            {{ $t('currencyRate.officialRate') }}
        </div>

        <table class="w-full" v-if="currency.length > 0">
            <thead class="thead">
            <tr class="h-11 bg-lightGray font-bold">
                <th class="pl-3">{{ $t('currencyRate.currencyName') }}</th>
                <th class="d-none d-sm-table-cell">{{ $t('currencyRate.symbol') }}</th>
                <th>{{ $t('currencyRate.change') }}</th>
                <th>{{ $t('currencyRate.rate') }}</th>
            </tr>
            </thead>
            <tbody class="tbody">
            <tr class="h-11">
                <td class="pl-3">1 {{ $t('currencyRate.' + currency[0].shortName.toLowerCase()) }}</td>
                <td class="d-none d-sm-block">{{ currency[0].shortName }}</td>
                <td v-if="getOfficialCurrencyRates.length > 0">
                            <span
                                v-if="getCompanyOrOfficialRate(currency[0].shortName, false, true).range > 0"> + </span>
                    <span
                        v-else-if="getCompanyOrOfficialRate(currency[0].shortName, false, true).range < 0"> - </span>
                    {{
                        Math.abs(getCompanyOrOfficialRate(currency[0].shortName, false, true).range).toFixed(2)
                    }}
                    <img v-if="getCompanyOrOfficialRate(currency[0].shortName, false, true).range > 0"
                         src="/promo/img/Vector22.png" alt="photo">
                    <img v-else-if="getCompanyOrOfficialRate(currency[0].shortName, false, true).range < 0"
                         src="/promo/img/Vector24.png" alt="photo">
                </td>
                <td v-if="getOfficialCurrencyRates.length > 0">
                    {{ getCompanyOrOfficialRate(currency[0].shortName, false, true, 2).rate }}
                </td>
            </tr>
            <tr class="h-11">
                <td class="pl-3">1 {{ $t('currencyRate.' + currency[1].shortName.toLowerCase()) }}</td>
                <td class="d-none d-sm-block">{{ currency[1].shortName }}</td>
                <td v-if="getOfficialCurrencyRates.length > 0">
                            <span
                                v-if="getCompanyOrOfficialRate(currency[1].shortName, false, true).range > 0"> + </span>
                    <span
                        v-else-if="getCompanyOrOfficialRate(currency[1].shortName, false, true).range < 0"> - </span>
                    {{
                        Math.abs(getCompanyOrOfficialRate(currency[1].shortName, false, true).range).toFixed(2)
                    }}
                    <img v-if="getCompanyOrOfficialRate(currency[1].shortName, false, true).range > 0"
                         src="/promo/img/Vector22.png" alt="photo">
                    <img v-else-if="getCompanyOrOfficialRate(currency[1].shortName, false, true).range < 0"
                         src="/promo/img/Vector24.png" alt="photo">
                </td>
                <td v-if="getOfficialCurrencyRates.length > 0">
                    {{ getCompanyOrOfficialRate(currency[1].shortName, false, true, 2).rate }}
                </td>
            </tr>
            </tbody>
        </table>


        <div class="grid grid-cols-12 gap-3 mt-5 container">
            <div class="col-span-12 md:col-span-6 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-20">
                    {{ $t('currencyRate.companyRate') }}
                </div>
                <div class="flex">
                    <div class="border border-gray-300 rounded font-bold text-main flex justify-center items-center px-3">{{ currency[0].shortName }}</div>
                    <b-form-input
                        class="border-gray-300 h-11 focus:ring-0"
                        list="my-list-id"
                        v-model="currentExchange.rateOne"
                    />
                    <datalist id="my-list-id" class="mb-2">
                        <option v-if="getCompanyCurrencyRates.length > 0">
                            {{
                                getCompanyOrOfficialRate(currency[0].shortName, true, false, 6).rate
                            }}
                        </option>
                        <option>{{
                                getCompanyOrOfficialRate(currency[0].shortName, false, true, 6).rate
                            }}
                        </option>
                    </datalist>
                </div>
            </div>

            <div class="col-span-12 md:col-span-6 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-20">
                    {{ $t('currencyRate.companyRate') }}
                </div>
                <div class="flex">
                    <div class="border border-gray-300 rounded font-bold text-main flex justify-center items-center px-3">{{ currency[1].shortName }}</div>
                    <b-form-input
                        class="border-gray-300 h-11 focus:ring-0"
                        list="my-list-id"
                        v-model="currentExchange.rateTwo"
                    />
                    <datalist id="my-list-id-rub" class="mb-2">
                        <option v-if="getCompanyCurrencyRates.length > 0">
                            {{
                                getCompanyOrOfficialRate(currency[1].shortName, true, false,6).rate
                            }}
                        </option>
                        <option>{{
                                getCompanyOrOfficialRate(currency[1].shortName, false, true, 6).rate
                            }}
                        </option>
                    </datalist>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-12 container mt-4 pb-4">
            <div class="col-start-10 col-span-3">
                <ButtonTag
                    :is-tw-main-btn="true"
                    :do-action="saveCompanyRate"
                    :is-w100="true"
                >
                    {{ $t('save') }}
                </ButtonTag>
            </div>
        </div>
    </Row>
</template>

<script>
import Row from "../../components/html/Row";
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import ButtonTag from "../../components/html/ButtonTag";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";

export default {
    name: "List",
    components: {
        ButtonTag,
        Row,
    },
    mixins: [validatorMixin, currencyRateMixin, currencyFormatMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'company.title', url: 'company'},
                {name: 'currencyRate.currencyRate'}
            ],
            currentExchange: {
                rateOne: '',
                rateTwo: '',
            },
            isWantSaveUSD: false,
            isWantSaveRUB: false,
            data: {
                rate: '',
                currency: '',
                company: '',
                baseCurrency: ''
            },
            dismissSecs: 2,
            dismissCountDown: 0,
        }
    },
    computed: {
        ...mapGetters([
            'getOfficialCurrencyRates',
            'getUserCompanyId',
            'getCurrencyByShortName',
            'getUserCompanyIdAt',
            'getCompanyCurrencyRates',
        ])
    },
    methods: {
        ...mapActions([
            'fetchUser',
            'fetchCurrencies',
            'pushCompanyCurrencyRate',
            'setBreadcrumbItems'
        ]),
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
            this.$root.showOverlay = false
        },
        showAlert() {
            this.dismissCountDown = this.dismissSecs
        },
        async saveCompanyRate() {
            if (this.currentExchange.rateOne !== '') {
                this.$root.showOverlay = true

                if (this.currentExchange.rateOne < 1) {
                    this.data.rate = (1 / this.currentExchange.rateOne).toFixed(4)
                    this.data.currency = this.getCurrencyByShortName(this.baseCurrencyShortName)['@id']
                    this.data.baseCurrency = this.currency[0]['@id']
                } else {
                    this.data.rate = this.currentExchange.rateOne
                    this.data.baseCurrency = this.getCurrencyByShortName(this.baseCurrencyShortName)['@id']
                    this.data.currency = this.currency[0]['@id']
                }

                this.data.company = this.getUserCompanyIdAt
                await this.pushCompanyCurrencyRate(this.data)
            }

            if (this.currentExchange.rateTwo !== '') {
                this.$root.showOverlay = true

                if (this.currentExchange.rateTwo < 1) {
                    this.data.rate = (1 / this.currentExchange.rateTwo).toFixed(4)
                    this.data.currency = this.getCurrencyByShortName(this.baseCurrencyShortName)['@id']
                    this.data.baseCurrency = this.currency[1]['@id']
                } else {
                    this.data.rate = this.currentExchange.rateTwo
                    this.data.baseCurrency = this.getCurrencyByShortName(this.baseCurrencyShortName)['@id']
                    this.data.currency = this.currency[1]['@id']
                }

                await this.pushCompanyCurrencyRate(this.data)
            }

            this.showAlert()
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    async mounted() {
        await this.fetchUser()
    },
}
</script>

<style scoped>

.b-alert-saved {
    position: absolute;
    z-index: 9999999999999;
    color: white;
    background-color: green;
    width: 100%;
    top: -5px;
    text-align: center;
}
</style>
